import angular from 'angular';
import eventsComponent from './events.component';
import EventsService from './events.service';
import eventsConfig from './events.config';

import FeaturedSliderModule from '../../home/featured-slider/featured-slider';

let eventsModule = angular.module('events',[])
  .component('events', eventsComponent)
  .service('eventsService', EventsService)
  .config(eventsConfig);

export default eventsModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/events/events.js
 **/